import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate, useSearchParams } from 'react-router-dom';
import api from '../../services/api';
import { setSession } from '../../store/authSlice';
import { setFoodStorageItem } from '../../utils/embeddedStorage';

export default function ShellSsoPage() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [error, setError] = useState('');

  useEffect(() => {
    const token = params.get('token');
    const returnUrl = params.get('return');
    if (!token) {
      setError('Token SSO no recibido');
      return;
    }
    (async () => {
      try {
        const { data } = await api.post('/auth/shell-exchange', { token });
        dispatch(setSession(data));
        setFoodStorageItem('token', data.accessToken);
        setFoodStorageItem('refresh', data.refreshToken ?? null);
        if (data.user) {
          setFoodStorageItem('user', JSON.stringify(data.user));
        }
        if (data.subscription != null) {
          setFoodStorageItem('subscription', JSON.stringify(data.subscription));
        }
        try {
          localStorage.setItem('d28d_shell', 'true');
          localStorage.removeItem('shellBranding');
        } catch { /* noop */ }
        // Opción A: no pintar --brand-* de gym/coach dentro de Food.
        try {
          const root = document.documentElement;
          root.style.removeProperty('--brand-primary');
          root.style.removeProperty('--brand-secondary');
        } catch { /* noop */ }
        const destHint = params.get('dest')
          || (typeof sessionStorage !== 'undefined' ? sessionStorage.getItem('d28d_food_dest') : null)
          || ''
        const nestPending = data.user?.pendingActivation === true
          || data.pendingActivation === true
          || String(data.subscription?.status || '').toUpperCase() === 'PENDING'
        const nestExpired = data.planExpired === true
          || data.user?.planExpired === true
          || String(data.subscription?.status || '').toUpperCase() === 'EXPIRED'
        const pending = nestPending || (destHint === '/pendiente-activacion' && !nestExpired)
        const expired = nestExpired
        if (returnUrl && !pending && !expired) {
          try {
            const u = new URL(returnUrl, window.location.origin);
            if (u.origin === window.location.origin) {
              window.location.replace(`${u.pathname}${u.search}${u.hash}` || '/dashboard');
              return;
            }
          } catch { /* no seguir return a otro puerto (p. ej. :3002) */ }
        }
        const destParam = pending
          ? '/pendiente-activacion'
          : expired
            ? '/plan-vencido'
            : (destHint === '/plan-vencido' || destHint === '/pendiente-activacion' ? '' : destHint);
        if (typeof sessionStorage !== 'undefined') {
          sessionStorage.removeItem('d28d_food_dest');
        }
        const role = String(data.user?.role || '').toUpperCase();
        const roleHome =
          role === 'SUPER_ADMIN' ? '/superadmin'
          : role === 'ADMIN' ? '/admin'
          : role === 'TRAINER' ? '/trainer'
          : '/dashboard';
        const target = destParam || roleHome;
        navigate(target.startsWith('/') ? target : `/${target}`, { replace: true });
      } catch (err: any) {
        setError(err.response?.data?.message || err.message || 'Error SSO');
      }
    })();
  }, [params, navigate]);

  return (
    <div className="min-h-screen grid place-items-center p-6">
      <div className="text-center max-w-md">
        <h1 className="text-xl font-semibold mb-2">Conectando con FOOD PLAN…</h1>
        {error ? (
          <>
            <p className="text-red-600 mb-4">{error}</p>
            <a href="/login" className="text-blue-600 underline">Ir a login Food</a>
          </>
        ) : (
          <p className="text-slate-600">Validando sesión única del shell…</p>
        )}
      </div>
    </div>
  );
}
